import { render, staticRenderFns } from "./ProjectRealisasiTable.vue?vue&type=template&id=06da0e47&scoped=true"
import script from "./ProjectRealisasiTable.vue?vue&type=script&lang=js"
export * from "./ProjectRealisasiTable.vue?vue&type=script&lang=js"
import style0 from "./ProjectRealisasiTable.vue?vue&type=style&index=0&id=06da0e47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06da0e47",
  null
  
)

export default component.exports